import { SideEditorPanel } from '@components/SideEditor/SideEditor';
import type { FC } from 'react';

// consts and types
import { ENABLE_CONTACT_DETAILS_OPTIONS, MenuItemsIndexDictionary } from '../../consts';
import { EmailSignatureSideEditorItems } from '../../types';
import EmailSignatureEditorContactDetailsDesignSection from './EmailSignatureEditorContactDetailsDesignSection';
import EmailSignatureEditorSaveContactSection from './EmailSignatureEditorSaveContactSection';
import EmailSignatureEditorSocialLinksDesignSection from './EmailSignatureEditorSocialLinksDesignSection';
// components
import EmailSignatureEditorThemeDesignSection from './EmailSignatureEditorThemeDesignSection';

const EmailSignatureEditorDesignPanel: FC<React.PropsWithChildren<{ trackCustomColor?: boolean }>> = ({
  trackCustomColor = false,
}) => {
  return (
    <SideEditorPanel index={MenuItemsIndexDictionary[EmailSignatureSideEditorItems.DESIGN]}>
      <EmailSignatureEditorThemeDesignSection trackCustomColor={trackCustomColor} />

      {ENABLE_CONTACT_DETAILS_OPTIONS && <EmailSignatureEditorContactDetailsDesignSection />}

      <EmailSignatureEditorSocialLinksDesignSection />

      <EmailSignatureEditorSaveContactSection />
    </SideEditorPanel>
  );
};

export default EmailSignatureEditorDesignPanel;
